import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import CallIcn from "../../styles/webroot/images/call-icn.png";
import mailIcn from "../../styles/webroot/images/mail-icn.png";
import tellephoneIcon from "../../styles/webroot/images/Fill_1.png";
import smallMailIcon from "../../styles/webroot/images/email.svg";
import whatsappIcon from "../../styles/webroot/images/whatsapp.png";
import { getUserDetail,saveFeedBack } from "@store/slices/commonId";
import secureStorage from "@src/config/encrypt";
import { ROLE, WHATSAPP_WEB_URL } from "@src/config/id/constant";
import { useSelector } from "react-redux";
import FullPageLoader from "@common/FullPageLoader";
import { toast } from "react-toastify";
import { useLanguage } from "@src/context/LanguageContext";

type SupportListProps = {
 
};

const SupportList = (props: SupportListProps) => {
  let auth = secureStorage.getItem("authAgentUserInfo");
  const roleId = auth?.user_data?.role_id;
  const userId = auth?.user_data?.id;
  const [loading, setLoading] = useState(false);
  const [userDetail, setUserDetail] = useState<any>({});
  const [feedback, setFeedback] = useState<any>("");
  const commonState = useSelector((state: any) => state.common);
  const dispatch: any = useDispatch();
  const {translations,language} = useLanguage();
  const [error,setError] = useState<any>({});

  const getUserDetailData = async (params: any) => {
    setLoading(true);
    dispatch(getUserDetail(params))
      .then((res: any) => {
        if (res && res.status === 200) {
          setUserDetail(res.data);
        }
        setLoading(false);
      })
      .catch((err: any) => {});
  };
  const handleClick = (type: string) => {
    if (type === "whatsapp") {
      const message = "Hello, I need assistance";
      const url = WHATSAPP_WEB_URL + encodeURIComponent(message);
      window.open(url, "_blank", "noreferrer");
    }
  };
  const submit = async () => {
    if(!feedback){
      setError({feedback:"Feedback is required"})
      return
    }
    setLoading(true);
    const payload = {
    feedback: feedback
   }
    dispatch(saveFeedBack(payload)).then((response: any) => {
      if (response && response.status === 200) {
        setFeedback("");
        toast.success(response.message);
      }
      setLoading(false);
    }).catch((err: any) => {});

  };

  const handleChange = (e: any) => {
    const updatedErrors = { ...error };
    if(updatedErrors['feedback'] && e.target.value) {
      delete updatedErrors['feedback'];
      setError(updatedErrors);
    }
    setFeedback(e.target.value);
  };

  useEffect(() => {
    if (userId) {
      getUserDetailData({ user_id: userId });
    }
  }, [userId]);

  return (
    <React.Fragment>
      <FullPageLoader show={loading} />
      <div className="container-fluid">
        <div className="lead-top-heading p-lg-t">
          <h1>{translations?.SUPPORT?.SUPPORT}</h1>
        </div>
        {/* Support Section */}
        <div className="col-md-4 col-xs-12 m-lg-t">
          <div className="task-summery-outer bg-white quick-support-outer">
            <div className="row">
              <div className="col-md-12 w-100">
                <div className="summery-heading">
                  <h2>{translations?.SUPPORT?.SUPPORT}</h2>
                </div>
                <div className="row">
                  <div className="col-md-6 col-xs-6">
                    <div className="quick-support-bg">
                      <img src={CallIcn} alt="Call Icon" />
                      <label>{translations?.SUPPORT?.SUPPORT}</label>
                      <span>9 AM to 6 PM</span>
                      <a
                        href={`tel:${commonState?.common?.CALL_US}`}
                        className="action-arrow"
                      >
                        <i className="ic-keyboard_arrow_right"></i>
                      </a>
                    </div>
                  </div>
                  <div className="col-md-6 col-xs-6">
                    <div className="quick-support-bg">
                      <img src={mailIcn} alt="Mail Icon" />
                      <label>
                        {translations?.SUPPORT?.WRITE_US}
                        <br />{language !== 'id' &&  translations?.SUPPORT?.MAIL}
                      </label>
                      <a
                        href={`mailto:${commonState?.common?.WRITE_US_MAIL}`}
                        className="action-arrow"
                      >
                        <i className="ic-keyboard_arrow_right"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bm Detail Section */}

        {
          roleId == ROLE.AGENT && (
            <div className="col-md-4 col-xs-12 m-lg-t">
              <div className="task-summery-outer bg-white quick-support-outer">
                <div className="bm-card">
                  <h2 className="bm-title">{translations?.SUPPORT?.BM_DETAIL}</h2>

                  <p className="bm-name">
                    {userDetail?.reportee_manager_list?.[0]?.name || ""} (
                    {userDetail?.reportee_manager_list?.[0]?.role_name || ""})
                  </p>

                  <div className="bm-item">
                    <div className="bm-left">
                      <img src={whatsappIcon} alt="Call Icon" />
                      <span>WhatsApp</span>
                    </div>
                    <i
                      className="ic-keyboard_arrow_right"
                      onClick={() => handleClick("whatsapp")}
                    ></i>
                  </div>

                  <div className="bm-item">
                    <div className="bm-left">
                      <img src={tellephoneIcon} alt="Call Icon" />
                      <span>
                        {userDetail?.reportee_manager_list?.[0]?.mobile || ""}
                      </span>
                    </div>
                    <a
                      href={`tel:${userDetail?.reportee_manager_list?.[0]?.mobile}`}
                      className="action-arrow"
                    >
                      <i className="ic-keyboard_arrow_right"></i>
                    </a>
                  </div>

                  <div className="bm-item">
                    <div className="bm-left">
                      <img src={smallMailIcon} alt="Call Icon" />
                      <span>
                        {userDetail?.reportee_manager_list?.[0]?.email || ""}
                      </span>
                    </div>
                    <a
                      href={`mailto:${userDetail?.reportee_manager_list?.[0]?.email}`}
                      className="action-arrow"
                    >
                      <i className="ic-keyboard_arrow_right"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )
        }
         {/* feedBack Section */}
        <div className="col-md-4 col-xs-12 m-lg-t">
          <div className="task-summery-outer bg-white quick-support-outer feedback-support-id">
            <div className="row">
              <div className="col-md-12 w-100">
                <div className="summery-heading">
                  <h2>{translations?.SUPPORT?.FEEDBACK}</h2>
                </div>
                  <p>{translations?.SUPPORT?.PARAGRAPH}</p>
                <div className="row p-lg-t">
                    <fieldset className="form-filed col-md-12">
                        <div className="material">
                            <textarea className='form-input' placeholder=' ' value={feedback} onChange={(e:any)=>handleChange(e)}></textarea>
                            <label data-label={translations?.SUPPORT?.FEEDBACK_PLACEHOLDER} className="form-label"></label>
                            <span className="error-txt">{error?.feedback}</span>
                        </div>
                    </fieldset>
                
                </div>
                <button className="btn btn-primary" onClick={()=>submit()}>{translations?.COMMON_MSG?.SUBMIT}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SupportList;
